import React from 'react';

const CsvIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="41"
    height="49"
    viewBox="0 0 41 49"
  >
    <g fill="none" fillRule="evenodd">
      <rect width="38" height="46" x="3" fill="#757D99" rx="1" />
      <rect width="38" height="46" y="3" fill="#DFE1E7" rx="1" />
      <rect
        width="16.418"
        height="1.59"
        x="5.63"
        y="29.667"
        fill="#47506B"
        rx=".795"
      />
      <rect
        width="10.418"
        height="1.59"
        x="5.63"
        y="34.8"
        fill="#47506B"
        rx=".795"
      />
      <rect
        width="22.418"
        height="1.59"
        x="5.63"
        y="39.933"
        fill="#47506B"
        rx=".795"
      />
      <text
        fill="#2D344B"
        fontFamily="ProximaNova-Regular, Proxima Nova"
        fontSize="16"
      >
        <tspan x="7" y="19">
          csv
        </tspan>
      </text>
    </g>
  </svg>
);

export default CsvIcon;



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/parent/components/CsvIcon.svg.jsx